import { useEffect, useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translateText } from '../utils/translate';

/**
 * Hook to translate text based on current language setting
 */
export function useTranslate(text: string) {
  const { language } = useLanguage();
  const [translated, setTranslated] = useState<string>(text);

  useEffect(() => {
    if (language === 'en' || !text) {
      setTranslated(text);
      return;
    }

    const fetchTranslation = async () => {
      try {
        const result = await translateText(text, language);
        setTranslated(result);
      } catch (error) {
        console.error('Translation error:', error);
        setTranslated(text);
      }
    };

    fetchTranslation();
  }, [text, language]);

  return translated;
}
